import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import {
  GenericDataResponse,
  DataTrendingRequestBody,
  RawHemsHistoricalData,
  HemsPayload,
  RefrigerationCircuitMessagesData,
  RefrigerationCircuitMessagesPayload,
  RawTrendingData,
  ViguideRecommendations,
  PropertySincePayload,
  PropertySinceResponse,
  AnalyticsApiModel,
  ConnectivityRanking,
} from './analytics.model';

@Injectable()
export class AnalyticsApi implements AnalyticsApiModel {
  private readonly endPointPrefix = 'iot/v1/analytics-api';

  constructor(private clientService: ClientService) {}

  getHemsPowerData(body: HemsPayload): Observable<{ data: RawHemsHistoricalData }> {
    const endpoint = `${this.endPointPrefix}/dataLake/hems/v0/timeseries`;

    return this.clientService.post(endpoint, body);
  }

  getHemsThermalData(body: HemsPayload): Observable<{ data: RawHemsHistoricalData }> {
    const endpoint = `${this.endPointPrefix}/dataLake/chronos/v0/thermal_energy`;

    return this.clientService.post(endpoint, body);
  }

  getTrendingData(payload: DataTrendingRequestBody): Observable<{ data: RawTrendingData[] }> {
    const endpoint = `${this.endPointPrefix}/dataLake/trending/v0/timeseries`;

    return this.clientService.post(endpoint, payload);
  }

  getRefrigerationCircuitMessages(
    payload: RefrigerationCircuitMessagesPayload
  ): Observable<{ data: RefrigerationCircuitMessagesData[] }> {
    const endpoint = `${this.endPointPrefix}/dataLake/trending/v0/refrigeration_messages`;

    return this.clientService.post(endpoint, payload);
  }

  /**
   * https://documentation-integration.viessmann-climatesolutions.com/vitoguide-installations/v2#vitoguide-installations_Get_Recommendations
   * @returns list of recommendations for devices that are assigned to user company and have Plus/Pro plan
   */
  getOptimizationRecommendations(): Observable<GenericDataResponse<ViguideRecommendations[]>> {
    const endpoint = `vitoguide/installations/v2/recommendations`;

    return this.clientService.get(endpoint);
  }

  /**
   * https://documentation.viessmann-climatesolutions.com/chronos-analyticsapi-mw-iot/v1#chronos-analyticsapi-mw-iot_Chronos_features_present_since
   * @returns list of (HEMS Thermal Energy) & (Consumption) properties which are available for a given gateway
   */
  getDeviceAvailableProperties(
    body: PropertySincePayload
  ): Observable<GenericDataResponse<PropertySinceResponse>> {
    const endpoint = `${this.endPointPrefix}/dataLake/chronos/v0/property_since`;

    return this.clientService.post(endpoint, body);
  }

  getConnectivityRanking(companyId: string): Observable<GenericDataResponse<ConnectivityRanking>> {
    const endpoint = `${this.endPointPrefix}/dataLake/viguide/v0/connectivity_ranking`;

    return this.clientService.post<GenericDataResponse<ConnectivityRanking>>(endpoint, {
      customer_id: companyId,
    });
  }
}
